import { FC, PropsWithChildren } from 'react';
import {
  PageContentLayout,
  PageHeaderLayout,
  SideMenu,
} from 'melp-design/components';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import { ROUTES } from 'config';
import { BenefitsDisabledFeatureAlert } from 'containers/benefits';

export const BenefitsLayout: FC<PropsWithChildren<{}>> = ({ children }) => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <Stack gap={2}>
      <BenefitsDisabledFeatureAlert />

      <PageHeaderLayout
        breadcrumbs={[
          {
            label: t('menu.benefits'),
          },
        ]}
      />

      <PageContentLayout
        sidebar={
          <SideMenu
            tabs={[
              {
                key: 'benefits',
                label: t('menu.benefits'),
                url: ROUTES.benefits.list,
                isActive: path === ROUTES.benefits.list,
              },
              {
                key: 'categories',
                label: t('benefits.benefit_types'),
                url: ROUTES.benefits.categories.list,
                isActive: path === ROUTES.benefits.categories.list,
              },
            ]}
          />
        }
      >
        {children}
      </PageContentLayout>
    </Stack>
  );
};
